export const TrainerIndexMockData = [
    {
        index: "1",
        name: "Sean Tarry",
        runs: "429",
        wins: "59",
        winperc: "13.75",
        winplaceperc: "55.48",
        second: "46.0",
        third: "43.0",
        stakes: "R 9,139,912.50"
    },
    {
        index: "2",
        name: "Justin Snaith",
        runs: "434",
        wins: "67",
        winperc: "15.44",
        winplaceperc: "60.83",
        second: "50.0",
        third: "56.0",
        stakes: "R 6,012,112.50"
    },
    {
        index: "3",
        name: "Mike de Kock",
        runs: "253",
        wins: "33",
        winperc: "13.04",
        winplaceperc: "59.68",
        second: "33.0",
        third: "25.0",
        stakes: "R 4,666,750.00"
    },
    {
        index: "4",
        name: "Alan Greeff",
        runs: "384",
        wins: "60",
        winperc: "15.63",
        winplaceperc: "58.33",
        second: "47.0",
        third: "46.0",
        stakes: "R 3,999,625.00"
    },
    {
        index: "5",
        name: "Brett Crawford",
        runs: "298",
        wins: "49",
        winperc: "16.44",
        winplaceperc: "60.40",
        second: "36.0",
        third: "27.0",
        stakes: "R 3,937,400.00"
    },
    {
        index: "6",
        name: "Candice Bass-Robinson",
        runs: "316",
        wins: "26",
        winperc: "8.23",
        winplaceperc: "51.27",
        second: "35.0",
        third: "40.0",
        stakes: "R 3,462,825.00"
    },
    {
        index: "7",
        name: "Yvette Bremner",
        runs: "308",
        wins: "37",
        winperc: "12.01",
        winplaceperc: "59.09",
        second: "47.0",
        third: "33.0",
        stakes: "R 3,207,625.00"
    },
    {
        index: "8",
        name: "Andre Nel",
        runs: "201",
        wins: "34",
        winperc: "16.92",
        winplaceperc: "68.16",
        second: "30.0",
        third: "32.0",
        stakes: "R 3,207,625.00"
    },
    {
        index: "9",
        name: "Paul Peter",
        runs: "212",
        wins: "30",
        winperc: "14.15",
        winplaceperc: "57.55",
        second: "31.0",
        third: "12.0",
        stakes: "R 2,834,725.00"
    },
    {
        index: "10",
        name: "St John Gray",
        runs: "213",
        wins: "17",
        winperc: "7.98",
        winplaceperc: "61.97",
        second: "20.0",
        third: "31.0",
        stakes: "R 2,681,175.00"
    },
    {
        index: "11",
        name: "J A Janse van Vuuren",
        runs: "193",
        wins: "27",
        winperc: "13.99",
        winplaceperc: "58.03",
        second: "27.0",
        third: "14.0",
        stakes: "R 2,656,100.00"
    },
    {
        index: "12",
        name: "Gavin Smith",
        runs: "418",
        wins: "34",
        winperc: "8.13",
        winplaceperc: "45.69",
        second: "35.0",
        third: "38.0",
        stakes: "R 2,645,100.00"
    },
    {
        index: "13",
        name: "Glen Kotzen",
        runs: "301",
        wins: "26",
        winperc: "8.64",
        winplaceperc: "47.84",
        second: "34.0",
        third: "24.0",
        stakes: "R 2,622,925.00"
    },
    {
        index: "14",
        name: "Dennis Drier",
        runs: "160",
        wins: "25",
        winperc: "15.63",
        winplaceperc: "59.38",
        second: "18.0",
        third: "24.0",
        stakes: "R 2,346,750.00"
    },
    {
        index: "15",
        name: "Duncan Howells",
        runs: "214",
        wins: "20",
        winperc: "9.35",
        winplaceperc: "56.54",
        second: "30.0",
        third: "25.0",
        stakes: "R 2,295,475.00"
    },
    {
        index: "16",
        name: "Geoff Woodruff",
        runs: "132",
        wins: "17",
        winperc: "12.88",
        winplaceperc: "64.39",
        second: "20.0",
        third: "19.0",
        stakes: "R 2,200,550.00"
    },
    {
        index: "17",
        name: "Vaughan Marshall",
        runs: "199",
        wins: "23",
        winperc: "11.56",
        winplaceperc: "53.27",
        second: "26.0",
        third: "24.0",
        stakes: "R 2,183,775.00"
    },
    {
        index: "18",
        name: "Alec Laird",
        runs: "153",
        wins: "19",
        winperc: "12.42",
        winplaceperc: "65.36",
        second: "18.0",
        third: "26.0",
        stakes: "R 2,105,175.00"
    },
    {
        index: "19",
        name: "Paul Matchett",
        runs: "146",
        wins: "13",
        winperc: "8.90",
        winplaceperc: "45.89",
        second: "22.0",
        third: "9.0",
        stakes: "R 2,050,000.00"
    },
    {
        index: "20",
        name: "Tara Laing",
        runs: "194",
        wins: "23",
        winperc: "11.86",
        winplaceperc: "56.70",
        second: "21.0",
        third: "25.0",
        stakes: "R 1,843,200.00"
    }
];